import { firebaseClient, auth } from "../../../../shared/utils/firebase/firebase.utils";

const isUserPremium = async () => {
    await auth.currentUser?.getIdToken(true);
    const decodedToken = await firebaseClient.auth().currentUser?.getIdTokenResult();
    // console.log(decodedToken);
    switch (decodedToken?.claims?.stripeRole) {
        case "personal":
            return {role: "personal", downloads: 30, paid: true};
        case "professional":
            return {role: "business", downloads: 100, paid: true};
        case "enterprise":
            return {role: "enterprise", downloads: 500, paid: true};
        default:
            return {role: "free", downloads: 10, paid: false};
    }
}

export default isUserPremium